import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './utils/rem.js';
import i18n from './locales/i18n'
import { applyRouteSeo } from './utils/applyRouteSeo'
import '@/assets/styles/fonts.css'
import lazyBackground from '@/directives/lazyBackground'
import { installElementPlus } from '@/plugins/elementPlus'

const app = createApp(App)
app.directive('lazy-bg', lazyBackground)
app.use(router)
app.use(i18n)
installElementPlus(app)
app.mount('#app')

router.isReady().then(() => {
  applyRouteSeo(router.currentRoute.value)
  document.dispatchEvent(new Event('render-event'))
})
